import { Navbar } from "./Navbar";
import { Seo } from "./Seo";
import { Footer } from "./Footer";
import { COMPANY } from "../data/company";

export const EmailText = ({ text }) => {
  const parts = String(text).split(COMPANY.email);
  return parts.map((p, i) => (
    <span key={i}>
      {p}
      {i < parts.length - 1 && (
        <a href={`mailto:${COMPANY.email}`} className="text-[#C8553D] underline underline-offset-4" data-testid="legal-email-link">
          {COMPANY.email}
        </a>
      )}
    </span>
  ));
};

export const LegalSection = ({ section, index }) => (
  <section className="mb-10" data-testid={`legal-section-${index}`}>
    <h2 className="font-display text-2xl sm:text-3xl mb-3">{section.heading}</h2>
    {(section.paragraphs || []).map((p, i) => (
      <p key={i} className="text-foreground/90 leading-relaxed mb-3">
        <EmailText text={p} />
      </p>
    ))}
    {section.bullets && (
      <ul className="space-y-2 mt-2">
        {section.bullets.map((b, i) => (
          <li key={i} className="flex gap-3 items-start p-4 rounded-xl border border-black/5 bg-white/60">
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#C8553D] shrink-0" />
            <span className="text-foreground/90 leading-relaxed"><EmailText text={b} /></span>
          </li>
        ))}
      </ul>
    )}
  </section>
);

export const LegalLayout = ({ page, testId, showUpdated = true, children, before }) => (
  <div className="min-h-screen grain relative" data-testid={testId}>
    <Seo title={page.title} description={page.description} path={page.path} />
    <Navbar />
    <main className="max-w-3xl mx-auto px-6 py-12">
      <span className="inline-flex text-xs uppercase tracking-widest text-[#C8553D] mb-4">{COMPANY.tradingName}</span>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4" data-testid="legal-h1">{page.h1}</h1>
      <p className="text-lg text-muted-foreground leading-relaxed mb-3 max-w-2xl">{page.intro}</p>
      {showUpdated && (
        <p className="text-xs text-muted-foreground mb-10" data-testid="legal-updated">Last updated {COMPANY.legalUpdated}</p>
      )}
      {before}
      {page.sections.map((s, i) => <LegalSection key={i} section={s} index={i} />)}
      {children}
    </main>
    <Footer />
  </div>
);
